<template>
  <v-row justify="space-around">
    <v-col cols="12" md="8">
      <!-- Registration number -->
      <v-text-field
          outlined
          clearable
          v-model="data.regNumber"
          :label="$t('settings/customer:overview.registration-number')"
          tabindex="1"
      />

      <!-- Bank Information -->
      <h4 class="primary--text font-weight-medium">{{ $t('settings/customer:edit.labels.bank-account') }}</h4>
      <!-- IBAN -->
      <v-text-field
          outlined
          clearable
          v-model="data.iban"
          :label="$t('settings/customer:edit.labels.iban')"
          tabindex="1"
      />
      <!-- BIC -->
      <v-text-field
          outlined
          clearable
          v-model="data.bic"
          :label="$t('settings/customer:edit.labels.bic')"
          tabindex="1"
      />
      <!-- Value added tax identification number (i.e. UID in Austria) of the company -->
      <v-text-field
          outlined
          clearable
          v-model="data.vatId"
          :label="$t('settings/customer:edit.labels.vatin')"
          tabindex="1"
      />

      <!-- Tags -->
      <TagComponent
          v-if="isAdmin"
          :values="data.tags"
          @input="value => data.tags = value"
          :label="$t('common:tags')"
      />

      <!-- Tags -->
      <TagComponent
          v-if="isAdmin"
          :values="data.blackTags"
          @input="value => data.blackTags = value"
          :label="$t('common:black-tags')"
      />

    </v-col>
  </v-row>
</template>

<script>
import {Role} from '@/modules/core/data/roles';
import Customer from '@/modules/core/data/customer';
import TagComponent from '@/modules/core/components/TagComponent';
import {mapGetters} from "vuex";

export default {
  name: "AdditionalInfoTab",
  components: {
    TagComponent
  },
  props: {
    customer: {
      type: Object,
      default: new Customer()
    }
  },
  data() {
    return {
      data: {}
    }
  },
  computed: {
  ...mapGetters('auth', ['isAdmin']),
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit('updateCustomer', this.data);
      }
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.data = Object.assign({}, this.customer);
  }
}
</script>